module.exports = __webpack_public_path__ + "static/media/23.c9807c23.jpg";